import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { AuditLog } from './useAuditLogs'

export function useAuditLogById(logId?: string) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<AuditLog>>(
    token && logId ? `/api/audit-logs/${logId}` : null,
    undefined,
    token ?? '',
  )

  return {
    log: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
